import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, IPolicyStatusDto } from '@/dtos';

export const QUERY_KEY = 'GET_POLICIES_STATUSES';

export interface PolicyStatusDto {
  id: number;
  policy_id?: number;
  status: string;
  valid_from: string;
  valid_to: string | null;
  display_status?: string;
}

export interface PolicyStatus {
  id: string;
  policyId?: string;
  status: string;
  validFrom: string;
  validTo: string | null;
  displayStatus?: string;
}

const formatData = (statuses: IPolicyStatusDto[]): PolicyStatus[] =>
  statuses?.map((item) => {
    const formattedItem: PolicyStatus = {
      id: toString(item.id),
      policyId: toString(item.policy_id),
      status: item.status as string,
      validFrom: item.valid_from as unknown as string,
      validTo: item.valid_to as unknown as string,
      // TODO: this field is absent
      // @ts-ignore
      displayStatus: item.display_status as string,
    };
    return formattedItem;
  }) as [];

const useGetPolicyStatusesQuery = (id?: string) => {
  const { isLoading, isSuccess, isError, data } = useQuery(
    [QUERY_KEY, id],
    () => api.get(API_URL.POLICIES_POLICY_STATUSES_BY_POLICY_ID(id || '')),
    {
      enabled: !!id,
    }
  );
  const statuses = useMemo(() => formatData(data?.data || []) as PolicyStatus[], [data]);

  return {
    statuses,
    isError,
    isLoading,
    isSuccess,
  };
};

export default useGetPolicyStatusesQuery;
